<template>
  <div
    class="row news-content content-container"
    id="news-content"
    v-if="load"
  >
    <div class="small-11 large-8" style="margin: 0 auto">
      <div class="node__content">
        <div
          class="field field--name-field-news-body field--type-text-long field--label-hidden field__item"
        >
          <p class="title">隐私条款</p>
          <div v-html="content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PrivateAgreement } from "@/api/index";
export default {
  components: {},
  data() {
    return {
      load: false,
      content: null,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    PrivateAgreement((res) => {
      this.load = true;
      this.$emit("complete", true);
      if (res.code == 0) {
        this.content = res.data.content;
      }
    });

    setTimeout(() => {
      document.getElementById("footer-privacy-link").classList.add("is-active");
    }, 100);
  },
  mounted() {
    document.querySelector("#header-content").style.borderBottom =
      "1px solid #f0f0f0";
  },
};
</script>
<style lang='less' scoped>
.field--name-field-news-body {
  border-top: none;
}
.title {
  width: fit-content;
  margin: 0 auto;
  border-bottom: 4px solid #e77500;
}
</style>